import type { IntlShape } from 'react-intl'
import { INTL_DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'

/** Date formatters from useIntlDateFormatter and useIntlDateRangeFormatter, passed in so the helpers stay pure. */
export interface TripDateFormatters {
  formatDate: (date: string, instruction: Intl.DateTimeFormatOptions) => string
  formatDateRange: (startDate: string, endDate: string, instruction: Intl.DateTimeFormatOptions) => string
}

export function formatOrderTileDates(formatters: TripDateFormatters, startDate?: string, endDate?: string): string | undefined {
  if (startDate && endDate) {
    return formatters.formatDateRange(startDate, endDate, INTL_DMY_CASUAL_SHORT_FORMAT)
  }
  return startDate ? formatters.formatDate(startDate, INTL_DMY_CASUAL_SHORT_FORMAT) : undefined
}

export function formatOrderTileOccupancyLabel(
  intl: IntlShape,
  occupancy?: App.Occupants,
): string | undefined {
  const parts: Array<string> = []
  const children = (occupancy?.children ?? 0) + (occupancy?.infants ?? 0) + (occupancy?.teenagers ?? 0)

  if (occupancy?.adults) {
    parts.push(intl.formatMessage(
      {
        id: 'HRV3fWizQHS2HBZiZQwR',
        defaultMessage: '{count, plural, one {# Adult} other {# Adults}}',
        description: 'Pluralised adult count for a booked stay, on trip planner chat booking tiles, booking tags and the chat landing page upcoming trips',
      },
      { count: occupancy.adults },
    ))
  }

  if (children) {
    parts.push(intl.formatMessage(
      {
        id: 'RC_fTV1qWDRFvzmFRdf-',
        defaultMessage: '{count, plural, one {# Child} other {# Children}}',
        description: 'Pluralised child count, including infants and teenagers, for a booked stay on trip planner chat booking tiles, booking tags and the chat landing page upcoming trips',
      },
      { count: children },
    ))
  }

  return parts.length ? intl.formatList(parts, { type: 'unit' }) : undefined
}
